(() => {
  class AvpMobileStickyAtc {
    constructor(button) {
      this.originalButton = button;
      this.media = window.matchMedia('(max-width: 749px)');
      this.originalVisible = true;
      this.bar = this.buildBar();
      this.stickyButton = this.bar.querySelector('[data-avp-sticky-submit]');
      this.label = this.bar.querySelector('[data-avp-sticky-label]');
      this.price = this.bar.querySelector('[data-avp-sticky-price]');
      document.body.appendChild(this.bar);

      this.stickyButton.addEventListener('click', () => this.submit());
      this.media.addEventListener?.('change', () => this.update());
      window.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update(), { passive: true });
      document.addEventListener('variant:change', () => requestAnimationFrame(() => this.sync()));
      this.originalButton.closest('form')?.addEventListener('change', () => requestAnimationFrame(() => this.sync()));

      this.buttonObserver = new MutationObserver(() => this.sync());
      this.buttonObserver.observe(this.originalButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.originalVisible = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0.15);
          this.update();
        },
        { threshold: [0, 0.15, 0.5, 1] }
      );
      this.visibilityObserver.observe(this.originalButton);

      this.sync();
    }

    buildBar() {
      const bar = document.createElement('div');
      bar.className = 'avp-mobile-sticky-atc';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Schnell zum Warenkorb');
      bar.innerHTML = `
        <div class="avp-mobile-sticky-atc__summary">
          <span>Dein Lieblingsstück</span>
          <strong data-avp-sticky-price></strong>
        </div>
        <button type="button" class="button button--primary avp-mobile-sticky-atc__button" data-avp-sticky-submit>
          <span class="avp-mobile-sticky-atc__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M3 4h2l1.7 10.1a2 2 0 0 0 2 1.7h7.8a2 2 0 0 0 1.9-1.4L21 7H6.1M10 20h.01M17 20h.01M14 9v4M12 11h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span data-avp-sticky-label>In den Warenkorb</span>
        </button>
      `;
      return bar;
    }

    getOriginalLabel() {
      const label = this.originalButton.querySelector('span:not(.loading__spinner)');
      return String(label ? label.textContent : this.originalButton.textContent || 'In den Warenkorb')
        .replace(/\s+/g, ' ')
        .trim();
    }

    getCurrentPrice() {
      const priceRoot = document.querySelector('#MainContent .product__info-container .price');
      if (!priceRoot) return '';
      const priceNode = priceRoot.classList.contains('price--on-sale')
        ? priceRoot.querySelector('.price__sale .price-item--sale')
        : priceRoot.querySelector('.price__regular .price-item--regular');
      return String(priceNode ? priceNode.textContent : priceRoot.textContent || '').replace(/\s+/g, ' ').trim();
    }

    sync() {
      const label = this.getOriginalLabel();
      this.label.textContent = label || 'In den Warenkorb';
      this.price.textContent = this.getCurrentPrice();
      const disabled =
        this.originalButton.disabled ||
        this.originalButton.getAttribute('aria-disabled') === 'true';
      this.stickyButton.disabled = disabled;
      this.stickyButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      this.update();
    }

    update() {
      const cartOpen = document.body.classList.contains('avp-cart-open');
      const modalOpen = Boolean(document.querySelector('quick-add-modal[open], dialog[open]'));
      const show =
        this.media.matches &&
        !this.originalVisible &&
        window.scrollY > 120 &&
        !this.stickyButton.disabled &&
        !cartOpen &&
        !modalOpen;

      this.bar.classList.toggle('is-visible', show);
      this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('avp-mobile-sticky-atc-visible', show);
    }

    submit() {
      if (this.originalButton.disabled) {
        this.originalButton.closest('.product__info-container')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.originalButton.click();
    }
  }

  const init = () => {
    const button = Array.from(
      document.querySelectorAll('#MainContent product-form .product-form__submit[name="add"]')
    ).find((candidate) => !candidate.closest('quick-add-modal'));

    if (button) new AvpMobileStickyAtc(button);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
